module.exports = __webpack_public_path__ + "img/1F1E9-1F1F0.b224ed79.svg";